import { createStore } from "vuex";
import UseApi from "@/store/useApi";
import mainData from "@/store/mainData.js";

export default createStore({
  modules: {
    UseApi,
    mainData,
  },
});
